/** @format */
export const LOYALTY_COOKIES = {
	cookies: {
		loyalty: {
			scoreCardGoldStatus: {
				cookieName: 'lg',
				cookieValue: 'Gold'
			}
		}
	}
};

export const GUEST_USER_ID = '-1002';
